import {
  AUTH_ACTIONS_CLASS,
  AUTH_CONTAINER_CLASS,
  AUTH_FIELDS_CLASS,
  AUTH_LINKS_ROW_CLASS,
  AUTH_LINK_CLASS,
  AuthPage,
  AuthPrimaryButton,
  AuthTextField,
} from "@/components/auth";

import { useForgotPasswordForm } from "@/hooks";
import { ReactHookFormDevelopmentTools } from "../../components/developmentTools";
import { Form, FormRootError } from "../../components/forms";
import { RouteLink } from "../../components/ui";

export const ForgotPassword = () => {
  const {
    form,
    form: {
      formState: { isSubmitting },
      control,
    },
    handleSubmit,
  } = useForgotPasswordForm({ defaultValues: { email: "" } });

  return (
    <Form {...form}>
      <div className={AUTH_CONTAINER_CLASS}>
        <form
          className="grid gap-6"
          onSubmit={handleSubmit}
        >
          <AuthPage
            title="Forgot my Password"
            subtitle="Please enter your registered email address to receive a password reset link on email to reset password."
          >
            <div className={AUTH_FIELDS_CLASS}>
              <FormRootError />

              <AuthTextField
                control={form.control}
                name="email"
                label="Email"
                inputProps={{ type: "email", placeholder: "Enter your email address" }}
              />

              <div className={AUTH_ACTIONS_CLASS}>
                <AuthPrimaryButton
                  disabled={isSubmitting}
                  isLoading={isSubmitting}
                >
                  Submit
                </AuthPrimaryButton>
              </div>

              <div className={AUTH_LINKS_ROW_CLASS}>
                <RouteLink
                  to="/auth/login"
                  className={AUTH_LINK_CLASS}
                >
                  Login
                </RouteLink>
                {" | "}
                <RouteLink
                  to="/auth/signup"
                  className={AUTH_LINK_CLASS}
                >
                  Register
                </RouteLink>
              </div>
            </div>
          </AuthPage>
        </form>

        <ReactHookFormDevelopmentTools
          // @ts-expect-error - FIXME:
          control={control}
          placement="top-left"
        />
      </div>
    </Form>
  );
};
